import { seriesValueGetter } from '../grid/utils/value-getters/series-getter';
import { sectorValueGetter } from '../grid/utils/value-getters/sector';
import { cusipValueGetter } from '../grid/utils/value-getters/cusip-value-getter';
import { DealsSeries } from '../helpers/deals/series';
import { DealVersion } from '../types/deal.types';

export function stateFinder(series) {
  const statesList = [];

  if (series && series[0]) {
    series.forEach((s) => {
      if (statesList.indexOf(s.state) === -1) {
        statesList.push(s.state);
      }
    });

    return statesList.join(', ');
  }

  return statesList.join(', ');
}

export function getSectors(deal: DealVersion) {
  return sectorValueGetter({ data: deal }).join(', ');
}

export function getPurpose(deal: DealVersion) {
  let subSectorData = seriesValueGetter('subSectors')({ data: deal })
    .map((subSectorCode) => DealsSeries.Sector.getSubSectors()[subSectorCode])
    .filter((data) => !!data);

  const filteredSubSectorData = subSectorData.filter((data) => !data.ignorable);

  if (filteredSubSectorData.length) {
    subSectorData = filteredSubSectorData;
  }

  return subSectorData.map((data) => data.label).join(', ');
}

export function getCusipRoot(deal: DealVersion) {
  return cusipValueGetter({ data: deal }).join(', ');
}

export function getIssuer(deal: DealVersion) {
  return deal.issuer ? deal.issuer.name : getConduitIssuer(deal);
}

function getConduitIssuer(deal: DealVersion) {
  return deal.series
    .map(
      ({ conduitIssuerDepartment }) =>
        conduitIssuerDepartment && conduitIssuerDepartment.name
    )
    .filter((data) => !!data)
    .reduce((prev, curr) => (!prev || prev === curr ? curr : 'Various'), null);
}

export function getObligor(deal: DealVersion) {
  const seriesObligor = deal.series
    .map(({ obligor }) => obligor && obligor.name)
    .reduce((prev, curr) => (!prev || prev === curr ? curr : 'Various'), null);

  if (!seriesObligor) {
    return deal.obligor ? deal.obligor.name : null;
  } else {
    return seriesObligor;
  }
}
